var _path, _rect, _line, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 6.68629 6.68629 4 10 4H30C33.3137 4 36 6.68629 36 10V14H4V10Z",
    fill: "#FFCC00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    rx: 6,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 14,
    x2: 35,
    y2: 14,
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6167 30H23.2917V28.26H19.6017L22.1667 24.915C22.7967 24.09 23.0667 23.265 23.0667 22.425C23.0667 20.655 21.9267 19.38 19.9317 19.38C18.1767 19.38 16.8867 20.58 16.7817 22.17L18.5217 22.5C18.6417 21.615 19.1367 21.12 19.8867 21.12C20.7417 21.12 21.1767 21.645 21.1767 22.5C21.1767 23.1 20.9967 23.61 20.3667 24.405L16.6167 29.25V30Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar-2.fa0a2c2303bb400c823836da085db8a2.svg";
export { ForwardRef as ReactComponent };